import { Pipe, PipeTransform } from "@angular/core";
import { DISABLE_REASON, LEGACY_DISABLE_REASON } from "@comunicare/comunicare-interfaces";

const DISABLE_REASONS = Object.values(DISABLE_REASON) as string[];
const LEGACY_REASONS = Object.values(LEGACY_DISABLE_REASON) as string[];

/**
 * Turns a stored deactivation reason into a translation key.
 *
 * A reason is either a DISABLE_REASON, one of the LEGACY_DISABLE_REASON values left on
 * patients deactivated before CMATE-8632, or free text typed by the practitioner. Free text is
 * returned untouched: the translate pipe hands back the keys it does not know.
 */
@Pipe({ name: "disabledReasonKey" })
export class DisabledReasonKeyPipe implements PipeTransform {
  transform(reason: string): string {
    if (!reason) {
      return "";
    }
    if (DISABLE_REASONS.includes(reason) || LEGACY_REASONS.includes(reason)) {
      return "model.patient.disablePatientReason." + reason;
    }
    return reason;
  }
}
